import { environment } from '../../../../../environments/environment';

export const INTERNAL_SUPPLIER_TERMINATIONS_ENDPOINT = `${environment.apiBaseUrl}/internal/mac/supplier-terminations`;
export const INTERNAL_SUPPLIER_TERMINATION_CREATE_ENDPOINT = (distributorId: string) =>
  `${environment.apiBaseUrl}/internal/mac/supplier-terminations/${distributorId}`;
export const INTERNAL_SUPPLIER_TERMINATION_APPROVE_ENDPOINT = (terminationId: number) =>
  `${environment.apiBaseUrl}/internal/mac/supplier-terminations/${terminationId}/approve`;
export const INTERNAL_SUPPLIER_TERMINATION_REJECT_ENDPOINT = (terminationId: number) =>
  `${environment.apiBaseUrl}/internal/mac/supplier-terminations/${terminationId}/reject`;
